export default class NetworkError extends Error {}
